import environment from '@app/environments/environment';
import * as models from '@app/models';
import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';

@Injectable()
export class USPSTierConfigService {
	private baseUrl = environment.apiGateway.apiUrl;
	private tierConfigUrl = '';

	constructor() {
		this.tierConfigUrl = this.baseUrl + 'USPSTierConfig/';
	}

	/**
	 *  Get all RateSets
	 */
	public async getSelectedRateSetRemotely(companyName: string, cancelToken?: CancelToken): Promise<models.IRateSet> {
		try {
			const url = this.tierConfigUrl + `${companyName}/SelectedRateSet/`;
			const res = await axios.get<models.IRateSet>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Get all USPS Tier configs
	 */
	public async getUSPSTierConfigs(cancelToken?: CancelToken): Promise<models.IUSPSTierConfig[]> {
		try {
			const url = this.tierConfigUrl;
			const res = await axios.get<models.IUSPSTierConfig[]>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Get all USPS Tier configs
	 */
	public async getUSPSTierConfigsForAccount(
		accountId: string,
		cancelToken?: CancelToken
	): Promise<models.IUSPSTierConfig[]> {
		try {
			const url = this.tierConfigUrl + accountId;
			const res = await axios.get<models.IUSPSTierConfig[]>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Create USPS Tier config
	 */
	public async createUSPSTierConfigs(data: any, cancelToken?: CancelToken): Promise<any> {
		try {
			const url = this.tierConfigUrl + 'Admin/';
			const res = await axios.post<any>(url, data, {
				cancelToken,
			});
			res.data.numberOfAssociatedAccounts = data.numberOfAssociatedAccounts;
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Update USPS Tier config
	 */
	public async updateUSPSTierConfigs(id: string, data: any, cancelToken?: CancelToken): Promise<any> {
		try {
			const url = this.tierConfigUrl + `${id}/` + 'Admin/';
			const res = await axios.put<any>(url, data, {
				cancelToken,
			});
			res.data.numberOfAssociatedAccounts = data.numberOfAssociatedAccounts;
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Delete USPS Tier config
	 */
	public async deleteUSPSTierConfigs(id: string, cancelToken?: CancelToken): Promise<boolean> {
		try {
			const url = this.tierConfigUrl + `${id}/` + 'Admin/';
			const res = await axios.delete(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/usps-tier-config.service.ts